module.exports = __webpack_public_path__ + "img/kw.8ca94313.svg";